export default __webpack_public_path__ + "static/media/Viaduct_Waelschenheuvel.de8fd265.png";